import ConfirmationDialog from '../../../../../components/ReusableComponents/ConfirmationDialog/index'
import styles from './CanadianCheckInstructions.module.scss'
import sampleCheck from './sampleCheck.jpg'

const CanadianCheckInstructions = ({ handleHide, isActivation, handleActivate }) => (
  <ConfirmationDialog
    title="Payment with Canadian checks"
    negativeMessage="Go back"
    positiveMessage={isActivation ? 'Use a Candian check' : 'OK'}
    onConfirm={isActivation ? handleActivate : handleHide}
    onClose={handleHide}
    theme="blacklist"
  >
    <div className={styles.dialogInner}>
      <div className={styles.intro}>
        <p>
          Directful currently can't process Canadian checks online. Using an US check you
          can pay your invoices instantly.
        </p>
        <p>
          However, if you need to use a Canadian check, you can send us a physical one.
          Using the following instructions:
        </p>
      </div>
      <img src={sampleCheck} alt="" />
      <div>
        <b>1:</b> Make check payable to SwayPay, Inc.
      </div>
      <div>
        <b>2:</b> Write a memo Memo: write the invoice number
      </div>
      <div>
        <b>3:</b> Send the check via regular mail to:
        <div className={styles.mailToAddress}>
          SwayPay, Inc, 1259 El Camino Real, Unit #1001, Menlo Park, CA 94025
        </div>
      </div>
    </div>
  </ConfirmationDialog>
)

export default CanadianCheckInstructions
